/*
 * @Author: JamesWong
 * @Description: 授权店铺中文包
 * @Date: 2018-11-29 17:15:51
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-07-30 10:00:43
 */
export default {
  authorizedChannel: '已授权店铺',
  deletedStore: '删除店铺',
  hint: '提示',
  deletedStoreTips: '删除后该店铺将不能使用POS登陆，确定删除该店铺吗? ',
  cancel: '取消',
  confirmDelete: '确定删除',
  addChannel: '新增店铺',
  addAuthorizedChannel: '新增授权店铺',
  order: '序号',
  storeNumber: '店铺编号',
  storeAbbreviation: '店铺简称',
  storeFullname: '店铺全称',
  confirm: '确定',
  searchAuthorizedChannel: '搜索已授权店铺',
  searchChannel: '搜索未授权店铺',
  authorizedChannelDeleted: '授权店铺删除成功！',
  authorizedChannelAdded: '授权店铺新增成功！',
  '渠道配置中心': '渠道配置中心',
  '下载模版': '下载模版',
  '导入': '导入',
  '导入教程': '导入教程',
  '支持通过本地excel表快速导入渠道,点击': '支持通过本地excel表快速导入渠道,点击',
  '下载模板': '下载模板',
  '模板第二行开始填写需导入的渠道编号，依次往下录入': '模板第二行开始填写需导入的渠道编号，依次往下录入',
  '选择全部': '选择全部',
  '取消': '取消',
  '确定': '确定',
  '提示': '提示',
  '行导入成功，以下': '行导入成功，以下',
  '行数据导入失败': '行数据导入失败',
  '渠道编号': '渠道编号',
  '知道了': '知道了'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/channel.js